export const data = [
    {id:0, title:'Home', path:'/'},
    {id:4, title:'Services', path:'/services'},
    {id:2, title:'Products', path:'/products'},
    {id:1, title:'About us', path:'/about'},
    {id:3, title:'Contact us', path:'/contact'}
]